import { useMutation } from '@apollo/client/react';
import { notify } from '@components/ui/molecules/Toast';
import { UpdateUserProfileDocument } from '@graphql/types';
import { useCallback } from 'react';

import type { UpdateUserProfileInput, UpdateUserProfileResponse } from '../types';

export const useUpdateMe = () => {
  const [updateUserProfileMutation, { loading: updateLoading }] =
    useMutation(UpdateUserProfileDocument);
  /**
   * Executes the update user profile mutation and returns the payload or throws.
   */
  const doUpdateMe = useCallback(
    async (id: string, data: UpdateUserProfileInput): Promise<UpdateUserProfileResponse> => {
      const response = await updateUserProfileMutation({
        variables: {
          updateUserProfileId: id,
          input: data,
        },
      });
      const updateUserProfileResponse = response.data?.updateUserProfile;

      if (!updateUserProfileResponse) {
        notify.error({ title: 'Update User Profile failed', description: 'No response from server' });
        throw new Error('Update User Profile failed');
      }

      notify.success({ title: 'Update User Profile successful' });

      return updateUserProfileResponse as UpdateUserProfileResponse;
    },
    [updateUserProfileMutation]
  );

  return { doUpdateMe, updateLoading };
};
